import { render, staticRenderFns } from "./invoice-card-info.vue?vue&type=template&id=f728ef00&"
import script from "./invoice-card-info.vue?vue&type=script&lang=js&"
export * from "./invoice-card-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports